var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeX = function SvgVolumeX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67,
    d: "m14.667 4-4 4m0-4 4 4M6.423 1.577l-2.11 2.11a1.4 1.4 0 0 1-.24.215.7.7 0 0 1-.194.08C3.803 4 3.721 4 3.56 4h-1.16c-.372 0-.56 0-.702.073a.67.67 0 0 0-.291.291c-.073.143-.073.33-.073.703v1.866c0 .374 0 .56.073.703a.67.67 0 0 0 .291.291C1.84 8 2.027 8 2.4 8h1.158c.163 0 .245 0 .321.019a.7.7 0 0 1 .193.08c.067.04.125.098.24.214l2.11 2.11c.286.286.43.428.552.438a.33.33 0 0 0 .28-.116c.08-.093.08-.295.08-.7v-8.09c0-.405 0-.606-.08-.7a.33.33 0 0 0-.28-.116c-.123.01-.266.153-.551.438"
  })));
};
export default SvgVolumeX;